module.exports = __webpack_public_path__ + "static/img/money_1.8e8519fe.png";